export const hotspotACode = 
`
  <HotspotA
    title="Risus viverra tellus cupidata dipiscing."
    description="Consectetur adipiscing elit, sed do incididunt ut labore et dolore magna aliqua."
    link="only text 16px"
    withIllustration={{
      name: 'thought-leadership-article-on-ddos',
      size: '240'
    }}
  />
`;

export const hotspotBCode = 
`
  <HotspotB
    title="Risus viverra tellus cupidatat adipiscing."
    description="Consectetur adipiscing elit, sed do incididunt ut labore et dolore magna do incididunt ut labore et daliqua."
    link="only text 16px"
  />
`;


export const hotspotCCode = 
`
  <HotspotC
    colorScheme="lb03"
    highlighted="Risus viverra"
    title="ascing at telus consequat."
    description="Consectetur adipiscing elit sed do incididunt ut labore et dolore magna aliqua viverra."
    link="only text 20px"
    withIllustration={{
      name: 'thought-leadership-article-on-ddos',
      size: '240'
    }}
  />
`;

export const hotspotDCode = 
`
  <HotspotD
    highlighted="Risus viat adicing at"
    title="telus intest celeque."
    description="Consectetur adipiscing elit sed do incididunt ut labore et dolore magna aliqua viverra."
    link="only text 20px"
    imageUrl="path/to/image"
  />
`;

export const hotspotSelfcareACode = 
`
  <HotspotSelfcareA
    label="Lorem ipsum dolor"
    highlighted="Lorem ipsum dolor"
    title="Lorem ipsum."
    description="Risus viverra adipiscing at in tellus integer scelerisque."
    link="only text 14px"
    imageUrl="path/to/image"
  />
`;

export const hotspotSelfcareBCode = 
`
  <HotspotSelfcareB
    highlighted="Lorem ipsum"
    title="Risus viverra."
    description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ut nibh viverra."
    withIllustration={{
      name: 'thought-leadership-article-on-ddos',
      size: '240'
    }}
  />
`;




// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/constants/hotspotsCode.js